import {
    ApiCommercePresentationDirectiveSchema,
    ApiCommerceSnapshotSchema,
    ApiCommerceStandaloneRewardV2Schema,
} from "@bridge-applications/pb-types";
import { z } from "zod";

const CommerceRewardCollectionSchema = z.object({
    orderId: z.uuid(),
    rewards: z.array(ApiCommerceStandaloneRewardV2Schema),
    imageUrls: z.record(z.string(), z.string()),
});

export type CommerceRewardCollection = z.infer<
    typeof CommerceRewardCollectionSchema
>;

export const CommerceSliceSchema = z.object({
    snapshot: ApiCommerceSnapshotSchema.nullable(),
    activePresentation: ApiCommercePresentationDirectiveSchema.nullable(),
    loadStatus: z.enum(["idle", "loading", "ready", "disabled", "error"]),
    mutationStatus: z.enum(["idle", "claiming", "checking-out"]),
    checkoutStatus: z.enum([
        "idle",
        "opening",
        "pending",
        "paid",
        "cancelled",
        "failed",
    ]),
    error: z.string().nullable(),
    rewardCollection: z
        .object({
            userId: z.string(),
            queue: z.array(CommerceRewardCollectionSchema),
            presentedOrderIds: z.array(z.uuid()),
        })
        .nullable()
        .default(null),
});

export type CommerceSlice = z.infer<typeof CommerceSliceSchema>;
